
import React from 'react';
import FieldTrip122025  from 'views/FieldTrip122025';

const Montessoripage = () => {
  return <FieldTrip122025/>;
};

export default Montessoripage;